import React, { useCallback, useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link, useNavigate } from "react-router-dom";
import { useHistory } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import { BASE_URL } from "../Pages/Config";
import axios from "axios";
import Cookies from "js-cookie";
import BuyerName from "./BuyerName";
import Buyercontact from "./Buyercontact";

import { formatDate } from "../components/dateUtils";

import { CountdownTimer } from "./CountDownTimer";
import UserHighestBid from "./UserHighestBid";
export default function SettingMybids() {
  const [showToast, setToastMessage] = useState("");
  const navigate = useNavigate();
  const login_user_id = Cookies.get("user_id");

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/user_my_bid.php?id=${userId}t=${Date.now()}`
      );
      console.log(response);

      if (response.data.success && Array.isArray(response.data.data)) {
        setProducts(response.data.data);
        console.log("dtaa", response.data.data);
      } else {
        console.error("Unexpected API structure");
        setProducts([]);
      }
    } catch (error) {
      console.error("Failed to fetch products", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProducts();
  }, []);

  const [userbid, setuserBid] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const userId = Cookies.get("user_id");

      if (!userId) return;
      try {
        const response = await axios.get(
          `${BASE_URL}/user_my_bid.php?id=${userId}&t=${Date.now()}`
        );

        console.log("API response:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setuserBid(response.data.data);
        } else {
          console.error("Unexpected API structure");
          setuserBid([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setuserBid([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  console.log("userbid", userbid);
  const deleteproduct = async (productId: number) => {
    // const confirmDelete = window.confirm("Are you sure you want to delete this product?");
    // if (!confirmDelete) return;

    console.log(productId);
    try {
      const response = await axios.get(
        `${BASE_URL}/testauction/delete_item.php?id=${productId}`
      );
      console.log(response);

      if (response.data.success) {
        setToastMessage("Product deleted successfully.");

        setTimeout(() => {
          navigate("/mybids");
          fetchProducts();
        }, 1500);
      } else {
        alert("Failed to delete product.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      setToastMessage(
        "An error occurred while deleting the product. Try again Later"
      );
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>MY BIDS</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  {loading ? (
                    <b>Loading...</b>
                  ) : (
                    <b>
                      My Bids {products.length}{" "}
                      {products.length < 1 ? "Item" : "Items"}
                    </b>
                  )}
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      key="loading"
                      className="loading-overlay"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "550px",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product) => (
                      <div
                        key={product.id}
                        className="col-xl-4 col-lg-4 col-md-6 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <Link
                              to={`/detail/${product.id}`}
                              className="card-img"
                            >
                              <img
                                src={
                                  product.photo
                                    ? `${BASE_URL}/${product.photo
                                      .split(",")[0]
                                      .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt={product.title}
                              />
                            </Link>
                            <ul className="view-and-favorite-area">
                              <li>
                                <span
                                  onClick={() => deleteproduct(product.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {/* add your delete icon here */}
                                </span>
                              </li>
                            </ul>
                            <CountdownTimer
                              closingTime={product.closing_time}
                            />
                          </div>
                          <div className="auction-card-content">
                            <p style={{ fontSize: "12px" }}>
                              {formatDate(product.closing_time)}
                            </p>
                            <h6>
                              <Link to="">{product.title}</Link>
                            </h6>
                            <div
                              className="details_buyer"
                              style={{ marginTop: "10px" }}
                            >
                              <h6>Item Id</h6>{" "}
                              <p>
                                <b>#{product.id}</b>
                              </p>
                            </div>

                            <UserHighestBid itemId={product.id} userId={login_user_id} />

                            <div className="details_buyer">
                              <h6>Seller</h6>{" "}
                              <p>
                                <Link  to={`/review/${product.user_id}`}>
                                   <BuyerName buyerId={product.user_id} />
                                </Link>
                            
                              </p>
                            </div>




                            <div className="details_buyer">
                              <h6>Top Bid</h6>{" "}
                              <p
                                style={{
                                  color: "#ebc32f",
                                  fontWeight: "800",
                                }}
                              >
                                {product.current_price} SAR
                              </p>
                            </div>

                            <div className="rate_btn">
                              <Link to={`/detail/${product.id}`}>
                                <button>View Item</button>
                              </Link>
                            </div>
                            {/* <div className="price-and-code-area">
                              <div className="price">
                                <span>Current Bid at:</span>
                                <strong>
                                  ${" "}
                                  {product.current_price == ""
                                    ? product.auction_start_price
                                    : product.current_price}
                                </strong>
                              </div>
                              <div className="code">
                                <span> # {product.id}</span>
                              </div>

                              
                            </div> */}
                            <div className="relise">
                              {/* <button>
                                  {product.current_price <=
                                  product.desired_price
                                    ? product.product_buyer_id != "0"
                                      ? "Someone Other buy this product"
                                      : "Desired Price Not Meet "
                                    : product.product_buyer_id !=
                                        login_user_id &&
                                      product.product_buyer_id != "0"
                                    ? "Someone Other buy thipps product"
                                    : "Higher bid placed after your price."}
                                </button> */}

                              {/* <button>
                                  {(() => {
                                    if (
                                      Number(product.current_price) <=
                                      Number(product.desired_price)
                                    ) {
                                      if (
                                        Number(product.buy_product_status) === 1
                                      ) {
                                        if (
                                          Number(product.buyer_id) ===
                                          Number(login_user_id)
                                        ) {
                                          return "You Win This555 Product";
                                        } else {
                                          return "Someone else bought this product";
                                        }
                                      } else if (
                                        new Date(product.closing_time) >
                                        new Date()
                                      ) {
                                      } else {
                                        return "Desired Price Not Met";
                                      }
                                    } else if (
                                      Number(product.buy_product_status) ===
                                        1 &&
                                      Number(product.buyer_id) ===
                                        Number(login_user_id)
                                    ) {
                                      return "You Win This Auction by Direct buy ";
                                    } else {
                                      if (
                                        product.buy_product_status == 1 &&
                                        product.buyer_id == login_user_id
                                      ) {
                                        const match = userbid.find(
                                          (bid) =>
                                            Number(bid.id) ===
                                              Number(product.id) &&
                                            Number(product.current_price) ===
                                              Number(bid.user_bid) &&
                                            Number(bid.current_price) >=
                                              Number(bid.desired_price)
                                        );

                                        return 
                                         "You Win This Auction";
                                      } else {
                                        const match = userbid.find(
                                          (bid) =>
                                            Number(bid.id) ===
                                              Number(product.id) &&
                                            Number(product.current_price) ===
                                              Number(bid.user_bid) &&
                                            Number(bid.current_price) >=
                                              Number(bid.desired_price)
                                        );
                                        return match
                                        ? "You Win This Auction"
                                        : "You Lost This Auction";
                                      }

                                      
                                    }
                                  })()}

                                  {product.current_price >
                                  product.desired_price && product
                                    ? "Desired Price Not Meet "
                                    : ""}
                                </button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}

      <Fotter />
    </>
  );
}
